import { WellframeApi } from 'store/api';

export interface ReenrollRequest {
  access_code: string;
}
export interface ReenrollResponse {
  success: boolean;
  message?: string;
}

export const enrollmentService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    reenrollUser: builder.mutation<ReenrollResponse, string>({
      query: (enrollmentId) => ({
        url: '/api/v4/reenroll',
        method: 'POST',
        body: { access_code: enrollmentId },
      }),
    }),
  }),
});

export const { useReenrollUserMutation } = enrollmentService;
